import React from 'react';
import { RiInformationLine } from 'react-icons/ri';
import { formatDateTimeFull } from '../../utils/dateUtils';
import DetailSection from './DetailSection';

/** ผู้ใช้แบบย่อที่ backend ส่งมากับ created_by / updated_by */
export interface MetaUser {
  id?: number;
  username?: string | null;
  full_name?: string | null;
}

export const metaUserName = (u?: MetaUser | string | null): string | null => {
  if (!u) return null;
  if (typeof u === 'string') return u || null;
  return u.full_name || u.username || (u.id ? `#${u.id}` : null);
};

export interface RecordMetaCardProps {
  createdAt?: string | null;
  createdBy?: MetaUser | string | null;
  updatedAt?: string | null;
  updatedBy?: MetaUser | string | null;
  /** แถวเพิ่ม (เช่น "ซิงค์ Flow Account ล่าสุด") */
  extra?: Array<{ label: string; value: React.ReactNode }>;
  title?: string;
}

/**
 * การ์ด "ข้อมูลเพิ่มเติม" ด้านขวาของหน้ารายละเอียด (สร้างเมื่อ/โดย · แก้ไขล่าสุดเมื่อ/โดย)
 * แก้ไขล่าสุดแสดงเฉพาะเมื่อเคยแก้จริง (updatedAt มีค่า) — แบบเดียวกับโมดัลบริษัทเดิม
 */
export const RecordMetaCard: React.FC<RecordMetaCardProps> = ({
  createdAt, createdBy, updatedAt, updatedBy, extra = [], title = 'ข้อมูลเพิ่มเติม',
}) => {
  const rows: Array<{ label: string; value: React.ReactNode }> = [
    { label: 'สร้างเมื่อ', value: formatDateTimeFull(createdAt ?? null) },
    { label: 'สร้างโดย', value: metaUserName(createdBy) || '-' },
  ];
  if (updatedAt) {
    rows.push({ label: 'แก้ไขล่าสุด', value: formatDateTimeFull(updatedAt) });
    rows.push({ label: 'แก้ไขล่าสุดโดย', value: metaUserName(updatedBy) || '-' });
  }
  rows.push(...extra);
  return (
    <DetailSection title={title} icon={<RiInformationLine />} testId="record-meta-card">
      <dl className="space-y-3">
        {rows.map((r) => (
          <div key={r.label}>
            <dt className="text-xs text-secondary-500">{r.label}</dt>
            <dd className="text-sm text-secondary-900 mt-1 [overflow-wrap:anywhere]">{r.value}</dd>
          </div>
        ))}
      </dl>
    </DetailSection>
  );
};

export default RecordMetaCard;
